/*global define*/
/*jshint devel:true*/
/**
 * Base Error Model
 * Represents an error.
 */
define(
	'BaseErrorModel',[
		'BaseModel'
	],
	function (BaseModel) {
		'use strict';
		/**
		 * @name BaseTransferModelError
		 * @class
		 */
		var BaseErrorModel = BaseModel.extend({
			className: 'BaseErrorModel',
			/**
			 * Define the custom id attribute name for this class
			 * @type {String}
			 */
			idAttribute: 'errorId',
			defaults: {
				errorId: null,
				errorMsg: null
			}
		});
		return BaseErrorModel;
	}
);

